/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S7_HeadingInputs */

const tr_onbilgi_s7_heading = /** @type {(inputs: Onbilgi_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Cayma Hakkı`)
};

const en_onbilgi_s7_heading = /** @type {(inputs: Onbilgi_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Right of Withdrawal`)
};

const de_onbilgi_s7_heading = /** @type {(inputs: Onbilgi_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Widerrufsrecht`)
};

const ru_onbilgi_s7_heading = /** @type {(inputs: Onbilgi_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Право на отказ от договора`)
};

/**
* | output |
* | --- |
* | "7. Right of Withdrawal" |
*
* @param {Onbilgi_S7_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s7_heading = /** @type {((inputs?: Onbilgi_S7_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S7_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s7_heading(inputs)
	if (locale === "de") return de_onbilgi_s7_heading(inputs)
	if (locale === "ru") return ru_onbilgi_s7_heading(inputs)
	return tr_onbilgi_s7_heading(inputs)
});